import { isExpired, isOverLimit } from "./containers/Active/helpers";

export const findMatchingBonusData = (freeSpinAndBonusItems, bonusList) => {
	return freeSpinAndBonusItems.map((item) => {
		const matchingBonus = bonusList.find((bonus) =>
			bonus.walletContributions.some(
				(contribution) => contribution.walletId === item.walletId
			)
		);
		return {
			...item,
			matchingBonus: matchingBonus || null,
		};
	});
};

export const prepareBonusData = (bonusList, balance) => {
	const normalBonuses = bonusList.filter(
		(item) =>
			item.bonus &&
			item.bonus.instruction.type !== "Freespin" &&
			item.walletContributions[0].wageringRatio !== 100
	);
	const filteredOverLimitBonuses = normalBonuses.filter((item) => !isOverLimit(item));
	const availableBonuses = filteredOverLimitBonuses.filter((item) => !isExpired(item));

	const freeSpinAndBonusItems = Object.values(balance).filter(
		(wallet) => wallet.type === "Bonus"
	);

	const existingWalletIds = availableBonuses.map(
		(bonus) => bonus.walletContributions[0].walletId
	);

	const matchedFreeSpinAndBonuses = findMatchingBonusData(
		freeSpinAndBonusItems.filter((wallet) => !existingWalletIds.includes(wallet.walletId)),
		bonusList
	);

	return availableBonuses.concat(matchedFreeSpinAndBonuses);
};

const filterActiveBonuses = (bonusList, balance) => {
	const normalBonuses = bonusList.filter(
		(item) =>
			item.bonus &&
			item.bonus.instruction.type !== "Freespin" &&
			item.walletContributions[0].wageringRatio !== 100
	);
	const filteredOverLimitBonuses = normalBonuses.filter((item) => !isOverLimit(item));
	const availableBonuses = filteredOverLimitBonuses.filter((item) => !isExpired(item));

	const freeSpinAndBonusItems = Object.values(balance).filter(
		(wallet) => wallet.type === "Bonus"
	);

	return availableBonuses.concat(freeSpinAndBonusItems);
};

export const filterBonusList = (bonusList, balance) => {
	const active = filterActiveBonuses(bonusList, balance);

	const completed = bonusList.filter(
		(item) =>
			item.bonus &&
			item.bonus.instruction.type !== "Freespin" &&
			item.walletContributions[0].wageringRatio === 100
	);

	const expired = bonusList.filter(
		(item) =>
			item.bonus &&
			item.bonus.instruction.type !== "Freespin" &&
			item.walletContributions[0].wageringRatio !== 100 &&
			(isExpired(item) || isOverLimit(item))
	);

	return { active, completed, expired };
};
